/* unplugin-vue-components disabled */import api from "!../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-39.use[1]!../../../../../node_modules/vue-loader/dist/stylePostLoader.js!../../../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-39.use[2]!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ecommerceProfitCalculator.vue?vue&type=style&index=0&id=7dfbd0ca&scoped=true&lang=css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};